import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from 'ng-jhipster';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-alert',
    template: `
        <div class="alerts" role="alert">
            <div *ngFor="let alert of alerts" [ngClass]="{\'alert.position\': true, \'toast\': alert.toast}">
                <ngb-alert [type]="alert.type" (close)="alert.close(alerts)">
                    <pre [innerHTML]="alert.msg"></pre>
                </ngb-alert>
            </div>
        </div>`
})
export class JhiAlertComponent implements OnInit, OnDestroy {

    alerts: any[];

    public static onError(leServiceAlert: AlertService, error: Response) {
        let errorFound = false;
        if (error !== null && typeof error !== 'undefined') {
            if (error.headers !== null && typeof error.headers !== 'undefined') {
                // traitement des erreurs type x-cadensapp-error envoyées par le back
                let errorKey = error.headers.get('x-cadensapp-error');
                let param = error.headers.get('x-cadensapp-params');
                if (errorKey != null) {
                    let entity = error.headers.get('x-cadensapp-entity');
                    let application = error.headers.get('x-cadensapp-application');
                    errorFound = this.onEntityError(leServiceAlert, application, entity, errorKey, param);
                } else {
                    if (error.status != null) {
                        errorFound = this.onStatusError(leServiceAlert, error.status);
                    }
                }
            }
            if (!errorFound) {
                if (error.json !== null && typeof error.json !== 'undefined') {
                    errorFound = true;
                    // traitement types d'erreurs autre que x-cadensapp-error
                    this.onErrorMessage(leServiceAlert, error.json(), null);
                } else {

                }
            }
        }
        if (!errorFound) {
            leServiceAlert.error('error.erreurInconnue', null, null);
        }
    }

    public static onEntityError(leServiceAlert: AlertService, application, entity, errorKey, param) {
        let messageKey = this.construitCleMessage(errorKey, entity, application);
        leServiceAlert.error(messageKey, param, null);
        return true;
    }

    public static onStatusError(leServiceAlert: AlertService, status) {
        let messageKey = 'error.' + status;
        leServiceAlert.error(messageKey, null, null);
        return true;
    }

    public static construitCleMessage(errorKey, entity, application) {
        errorKey = errorKey == null ? 'error.erreurInconnue' : errorKey;
        let messageKey = null;
        if (entity != null) {
            if (application != null && ['candidature', 'cursus', 'referent'].indexOf(entity) >= 0) {
                messageKey = application + '.' + entity + '.' + errorKey;
            } else {
                messageKey = entity + '.' + errorKey;
            }
        } else {
            messageKey = errorKey;
        }
        return messageKey;
    }

    public static onErrorMessage(leService: AlertService, error: any, params?: any) {
        if (error !== null && typeof error !== 'undefined') {
            if (error.message) {
                if (error.message.indexOf('SendFailedException') > 0) {
                    leService.error('error.transmissionmailnotsent', params != null ? params : null, null);
                } else {
                    leService.error(error.message, params != null ? params : null, null);
                }
            } else {
                leService.error(error, params != null ? params : null, null);
            }
        } else {
            leService.error('error.erreurInconnue', params != null ? params : null, null);
        }
    }

    public static onSuccessMessage(leService: AlertService, success: any, params?: any) {
        if (success !== null && typeof success !== 'undefined') {

            if (success.message) {
                leService.success(success.message, params != null ? params : null, null);
            } else {
                leService.success(success, params != null ? params : null, null);
            }
        } else {
            leService.success('error.erreurInconnue', params != null ? params : null, null);
        }
    }

    constructor(private alertService: AlertService) {
    }

    ngOnInit() {
        this.alerts = this.alertService.get();
    }

    ngOnDestroy() {
        this.alerts = [];
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/alert/alert.component.ts